export default __webpack_public_path__ + "80f0895abf7b266d34484785e4d25ce3.ogg";